import { Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from '@/components/ui/sonner'
import { AuthProvider } from './contexts/AuthContext'
import { useAuthContext } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import HostedUIAuth from './components/HostedUIAuth'
import AuthCallback from './components/AuthCallback'
import Layout from './components/Layout'
import Dashboard from './components/Dashboard'
import DeviceList from './components/DeviceList'
import ContentManager from './components/ContentManager'
import RegistrationCodes from './components/RegistrationCodes'
import UserManagement from './components/UserManagement'
import ClientManagement from './components/ClientManagement'

function AppRoutes() {
  const { user, signOut } = useAuthContext()

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<HostedUIAuth />} />
      <Route path="/auth" element={<AuthCallback />} />
      
      {/* Protected routes */}
      <Route path="/" element={
        <ProtectedRoute>
          <Layout user={user} signOut={signOut}>
            <Navigate to="/dashboard" replace />
          </Layout>
        </ProtectedRoute>
      } />
      
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <Layout user={user} signOut={signOut}>
            <Dashboard />
          </Layout>
        </ProtectedRoute>
      } />
      
      <Route path="/devices" element={
        <ProtectedRoute>
          <Layout user={user} signOut={signOut}>
            <DeviceList />
          </Layout>
        </ProtectedRoute>
      } />
      
      <Route path="/content" element={
        <ProtectedRoute>
          <Layout user={user} signOut={signOut}>
            <ContentManager />
          </Layout>
        </ProtectedRoute>
      } />
      
      <Route path="/codes" element={
        <ProtectedRoute>
          <Layout user={user} signOut={signOut}>
            <RegistrationCodes />
          </Layout>
        </ProtectedRoute>
      } />
      
      <Route path="/users" element={
        <ProtectedRoute>
          <Layout user={user} signOut={signOut}>
            <UserManagement />
          </Layout>
        </ProtectedRoute>
      } />
      
      <Route path="/clients" element={
        <ProtectedRoute>
          <Layout user={user} signOut={signOut}>
            <ClientManagement />
          </Layout>
        </ProtectedRoute>
      } />
      
      {/* Catch all route */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  )
}

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
      <Toaster />
    </AuthProvider>
  )
}

export default App